document.addEventListener("DOMContentLoaded", function () {
  function getCurrentPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get("page");

    if (pageParam) {
      return parseInt(pageParam);
    }

    return 1;
  }

  function positionMobileFeaturedImages() {
    const productGrid = document.querySelector(".product-grid");
    if (!productGrid) return;

    const currentPage = getCurrentPage();

    const mobileFeaturedImages = productGrid.querySelectorAll(
      ".featured-image-block--mobile"
    );

    const productItems = productGrid.querySelectorAll(
      ".grid__item:not(.featured-image-block)"
    );

    mobileFeaturedImages.forEach((mobileImage) => {
      const mobileRow = parseInt(mobileImage.dataset.mobileRow);
      const mobileColumn = parseInt(mobileImage.dataset.mobileColumn);
      const pageNumber = parseInt(mobileImage.dataset.pageNumber) || 1;

      if (pageNumber === currentPage && mobileRow && mobileColumn) {
        const targetPosition = (mobileRow - 1) * 2 + mobileColumn;

        if (productItems[targetPosition - 1]) {
          productItems[targetPosition - 1].parentNode.insertBefore(
            mobileImage,
            productItems[targetPosition - 1]
          );
        }
      } else if (pageNumber !== currentPage) {
        mobileImage.style.display = "none";
      } else {
        // Show mobile featured images that belong to current page
        mobileImage.style.display = "block";
      }
    });
  }

  positionMobileFeaturedImages();

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(positionMobileFeaturedImages, 250);
  });

  let currentUrl = window.location.href;
  const checkForPageChange = function () {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      setTimeout(positionMobileFeaturedImages, 500);
    }
  };

  setInterval(checkForPageChange, 1000);

  document.addEventListener("shopify:section:load", function () {
    setTimeout(positionMobileFeaturedImages, 100);
  });

  document.addEventListener("shopify:block:select", function () {
    setTimeout(positionMobileFeaturedImages, 100);
  });

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    return originalFetch.apply(this, args).then((response) => {
      if (args[0] && typeof args[0] === "string" && args[0].includes("page=")) {
        setTimeout(positionMobileFeaturedImages, 300);
      }
      return response;
    });
  };

  document.addEventListener("click", function (e) {
    if (
      e.target.closest(".pagination__link") ||
      e.target.closest("[data-page]")
    ) {
      setTimeout(positionMobileFeaturedImages, 500);
    }
  });
});
